import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
	toggleFilterButton
} from '../actions';

class FilterButton extends Component {

	toggleFilter( page, toggle ) {
		this.props.toggleFilterButton( page, !toggle );
	}

	render() {
		const page = this.props.page;
		const toggle = (typeof this.props.filterButtonState[ page ] === 'undefined'
		               ) ? false : this.props.filterButtonState[ page ];
		return (
			<button className="filter-button btn-primary" onClick={ this.toggleFilter.bind( this, page, toggle ) } type="button">Filter
				<span className="glyphicon glyphicon-filter" aria-hidden="true" />
				<span className="sr-only">Filter {page}</span>
			</button>
		);
	}

}

function mapStateToProps( { filterButtonState } ) {
	return {
		filterButtonState
	};
}

export default connect( mapStateToProps, {
	toggleFilterButton
} )( FilterButton );